var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 484 483",
    width: 484,
    height: 483,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete-button-svgrepo-com") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 391,
    height: 483,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYcAAAHjAQMAAADytUFxAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAAw51jJtpVYwAAAAJ0Uk5TAP9bkSK1AAAEzElEQVR4nO2cbW4UMQyGx4AE/+gNyE3gZm1vRm9CbkD/UYkyjO18zcaT2CO6WglbYjtM59nGfp3EiZSBRbb7h9cP8m9Avv3557LEYCFW/PfOQHz8hZ9P3/TE1+/4+XynJ1b+FJslEtyoZXl80BIYKbQYtAS7sSwvn7TEmn6KIkoE/Bn+VriXHZddl4jsuOy6RHz5ka8kDSXivrRFCpZErOVKCpZA1FCJeSIQ73+Pv7C/VYMrhlcganDF8ApEDa6WyHmIJggiEFUOURCBWJtrQZCeaOQQBfkXRCug+I3dHRYwBg5yL+ERAelv9aNcT5DkGFWKsoag1sTQXKgIbD41qxe9JzBJKKgUZi3ByYGO9GnSE/gcf3Nl50QMeIVR6xOrJzAROaaojJbguxisPrE6giIE5VJJ5MdW8YHLG9iU3HgMgo7IIdUTWWgUpEv3jsCQxsDXmGI2AiXs0r0j2qfsBP49HZHbrifyTYxbDDMC43OewIxRESX7zhFdR++ILTNqL1pvktjS/Yho574jSywT7fR6bDEUYjctHRtHnYi2ShgZZSUR7Xw8Mur/RKyTJ3fNQmI/V44MOw4SbekyNnQECY0YbCgJElo3eLAEtRpo6DpYHCfXweI4uQ7apGKLAQl9qChYoM8RtC1PwBJcCi9YgkvhBVNwUQ1Qdw62xwcwyYGCgEkOFMRKPN+BSUAmLAKihGASECU8QbDkB+v9na38YCIONg92Rk9uBCWJuEjujKIKTMSgISg7HoHSSlzsd8aPEqHxe0mOPIFcosq2FkLnOLvOhLwx0hsmbQT6DDqCdoOIkLdreqP6DsTqcUA8E6HJETSqU5FQypEqG9g6lIl4QUIrIEl4ktBKToO6nXgFqYQ6NCylbo/YkpCIGG6MWG+P2LqtE29GXEnzk/3jGr1WP/oQYR+vThH6cTePosaR2jrjvJhmNTtR5kHjXGufzy01A1cZlroEPYim2gdL4zP1FZVyuvBSDXemTjTUorSKAK6Qda7TmgAMNTW1ZqupjZW+ncDVhH3FYifs6yj76s6+grStUu0Ermvta2f7+ty+B3Bin8G+l2HfYbGEl3dxLOEF625U2lsyBAvHAyT02Zv3yOz7cHrXYTHuJ9L4TIRWdZo1rkZow7v7G/NJJ+9AO+GEE0444YQTTjjhhBNOOOGEE0444YQTTjjhhBNOOOGEE0444YQTTjjhhBNOOOGEE0444YQTTjjhhBNOOHF1Ag/a/jdEPh58TWJ+xjYfpX5Dorw9KxN8oSba94MdWXkLWCFmB03tRHmbWSFmJ3/3hPg2tAsr31oIauOEoJYXgjJgYOXtckS0b6o7sq1nXxCzI7Zb9+CHCzFL3vLuPv4QX/63s/qqQNj/99DqOwgrMRYEg9sQ1MgYRgQGl11lAgMxDhY+cUkMXW/OODOB8gwdoROcHTFShM4kclowoTvcZydiqITutCU7yoTuaKqd4KGACd2JTmg/NWeFk8QpYzVnQPfE/cOcSAongkSfWErVRGgkTGNHIjQSxtASGkFSbidCIwjsf8wFyT0ujyBzQXL3ycQ8vHkcyMQ8vDHsiXl48zCQiXmw4OLn1PUybhRi5nqZXwoxc6SMZoWYaFhHzDoHjLtIHZUrMY4WCFfD/G0qir/4Jo5egM8XiwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 174,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAACuAQMAAAD9HeTQAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAAw51jJtpVYwAAAAJ0Uk5TAP9bkSK1AAAAVklEQVR4nGNksHdsYGT891CBkf3HTw5G/g9/WRjlH/xnYrQ/wMAIIhoZ6xsgxEHG/wzoxMNRYpQYWcRBJAKWNRoh2UX+AZgA5h5wZmL891GAkaGesQEAO21BHl8M1ikAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 174,
    id: "img3",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAACuAQMAAAD9HeTQAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAAw51jJtpVYwAAAAJ0Uk5TAP9bkSK1AAAAVElEQVR4nGNksHdsYGT891CBkf3HTw5G/g//mRjlHzAwMtofABL1DQyNcOIg438GJOLhKDFKjEDiIIQAZwgY0QjJLuCMA85C4MzE+O+jACNDvaMDAFqTQH7CDcqZAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 174,
    id: "img4",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAACuAQMAAAD9HeTQAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAAw51jJtpVYwAAAAJ0Uk5TAP9bkSK1AAAAVUlEQVR4nGNksHdsYGT891CBkf3HTw5G/g//mRjlHwAJ+wMMjCCikbG+AUIcZPzPgEQ8HCVGiZFKHIRkCBjRCMkp8g+AeQachcCZifHfRwFGhnrGBgC8n0IeBTRRMgAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 47,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    href: "#img2",
    x: 159,
    y: 249
  }), /*#__PURE__*/React.createElement("use", {
    href: "#img3",
    x: 229,
    y: 249
  }), /*#__PURE__*/React.createElement("use", {
    href: "#img4",
    x: 299,
    y: 249
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/delete-button.1f2bdb8ca5659bcb57d16c71e1a05705.svg";
export { ForwardRef as ReactComponent };